export default __webpack_public_path__ + "static/media/Plissee 18 mm seitlich ausmessen front.4a19cc26.jpg";